import { Link } from "react-router-dom";
import type { SanitizedSectionArticle, Tag } from "@app/types/Cue";
import { BlockTitle } from "@blocks/Blocks";
import cx from "classnames";

import PodcastsKeywordsStories from "./PodcastsKeywordsStories";

export type PodcastsKeywordsStoriesProps = {
  rootClassName?: string;
  blockTitle: string;
  description: string;
  spotify_link: string;
  apple_link: string;
  articles: SanitizedSectionArticle[];
  tag: Tag;
};

export default function PodcastsKeywords({
  rootClassName,
  blockTitle,
  description,
  spotify_link,
  apple_link,
  articles,
  tag,
}: PodcastsKeywordsStoriesProps): React.ReactElement {
  return (
    <>
      {articles.length > 0 ? (
        <section
          className={rootClassName}
          data-testid="podcasts-keyword-component"
        >
          <BlockTitle
            rootClassName="mb-4"
            link={tag.uri.replace("main/", "/keywords/")}
            text={blockTitle?.toUpperCase()}
          />

          <p className={cx("mb-4 font-public-sans text-base", "lg:text-lg")}>
            {description}
          </p>

          <div className="mb-7">
            <span className="mr-2">Subscribe:</span>

            <Link
              className="mr-2 border-r border-gray-850 pr-2 text-lg font-semibold hover:underline"
              to={spotify_link}
              rel="noreferrer"
              target="_blank"
            >
              Spotify
            </Link>

            <Link
              className="text-lg font-semibold hover:underline"
              to={apple_link}
              rel="noreferrer"
              target="_blank"
            >
              Apple Podcasts
            </Link>
          </div>

          <div className="stories flex snap-x gap-6 overflow-x-auto">
            {articles.map((article) => {
              return (
                <PodcastsKeywordsStories article={article} key={article.id} />
              );
            })}
          </div>
        </section>
      ) : null}
    </>
  );
}
